import React from "react";
import { Link } from "react-router-dom";
import { brand } from "../content/siteContent";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-navy flex items-center justify-center relative overflow-hidden">
      <div className="absolute inset-0 blueprint opacity-50" />
      <div className="container-page relative text-center">
        <p className="eyebrow text-teal">Error 404</p>
        <h1 className="mt-4 font-display font-extrabold text-white text-6xl lg:text-8xl tracking-tight">404</h1>
        <p className="mt-4 text-white/70 text-base max-w-md mx-auto">
          The page you were looking for could not be found.
        </p>
        <Link
          to="/"
          data-testid="notfound-home-link"
          className="mt-8 inline-flex items-center gap-2 bg-teal text-white font-display font-semibold text-sm rounded-sm px-6 py-3.5 hover:bg-[#08929f] transition-colors duration-300"
        >
          Return to {brand.shortName}
        </Link>
      </div>
    </div>
  );
}
